import { Image } from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';
import { FileDownloadButton } from 'shared_DEPRECATED/components/File';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';

import { ModalBody, ModalHeader } from 'shared/components/Modal';
import { Typography } from 'shared/components/Typography';

import styles from 'features/journal/components/Card/Card.module.css';

type TJournalCardImageModal = {
  src: string;
  contentType: string;
};

export function JournalCardImageModal({
  src,
  contentType,
}: TJournalCardImageModal) {
  return (
    <>
      <ModalHeader>
        <Box style={{ width: '90%' }}>
          <Flex justifyContent="space-between" alignItems="center">
            <Typography as="h3" type="body" fontWeight="semibold" color="black">
              Preview image
            </Typography>
            <>
              <Spacer size="xsm" />
              <FileDownloadButton url={src} />
            </>
          </Flex>
        </Box>
      </ModalHeader>
      <ModalBody>
        <Image
          src={src}
          alt={src}
          className={styles['card-image__preview']}
          data-testid="challenge-notes-card-image-modal-content"
          contentType={contentType}
          fallbackBackground="var(--bgSecondary)"
        />
      </ModalBody>
    </>
  );
}
